import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Input } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import ColorPicker from "components/common/ColorPicker/ColorPicker";
import SubmitButton from "components/common/SubmitButton";
import { parsePostingStyle, serializePostingStyle } from "./styleUtils";

const EditLedgerCardSetting = ({ item, onSubmit, cancelEdit }) => {
  const parsed = parsePostingStyle(item?.style);

  const [postingName, setPostingName] = React.useState(item?.postingName ?? "");
  const [textColour, setTextColour] = React.useState(parsed.color);
  const [rowColour, setRowColour] = React.useState(parsed.backgroundColor);
  const [errors, setErrors] = React.useState({});
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async () => {
    const newErrors = {};
    if (!postingName.trim()) newErrors.postingName = "Posting Name is required";
    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    const style = serializePostingStyle(rowColour, textColour);
    setIsSubmitting(true);
    try {
      await onSubmit({ ...item, postingName, postingType: item?.postingType, style });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      title={`Edit ${item?.postingName}`}
      onClose={cancelEdit}
      width={600}
    >
      <div className="p-3 ps-4">
        <div className="mb-3">
          <Label className="label my-1 w-100">Posting Name</Label>
          <Input
            value={postingName}
            onChange={(e) => {
              setPostingName(e.target.value);
              if (e.target.value.trim()) setErrors((prev) => ({ ...prev, postingName: "" }));
            }}
            style={{ width: "263px", height: "32px" }}
          />
          {errors.postingName && (
            <div className="fs-sm my-1 text-danger"><i>{errors.postingName}</i></div>
          )}
        </div>

        <div className="mb-3">
          <Label className="label my-1 w-100">Posting Type</Label>
          <Input value={item?.postingType ?? ""} disabled />
        </div>

        <div className="mb-3">
          <Label className="label my-1 w-100">Text Color</Label>
          <ColorPicker
            value={textColour}
            onChange={(e) => setTextColour(e?.target?.value ?? e)}
            name="textColour"
          />
        </div>

        <div className="mb-3">
          <Label className="label my-1 w-100">Row Color</Label>
          <ColorPicker
            value={rowColour}
            onChange={(e) => setRowColour(e?.target?.value ?? e)}
            name="rowColour"
          />
        </div>
      </div>

      <div className="dialog-footer">
        <button
          className="bgBtnSecondary common-btn me-2"
          onClick={cancelEdit}
          type="button"
        >
          Cancel
        </button>
        <SubmitButton
          className="me-3"
          onClick={handleSubmit}
          isLoading={isSubmitting}
        >
          Update
        </SubmitButton>
      </div>
    </Dialog>
  );
};

export default EditLedgerCardSetting;
